import { useIntl } from 'react-intl'
import { z } from 'zod'

export function useSignInSchema(mode: 'email' | 'phone' = 'email') {
  const intl = useIntl()

  const emailSchema = z.string().email(
    intl.formatMessage({
      id: 'validation.invalid_email',
      defaultMessage: 'Type a valid email address',
    }),
  )

  const phoneSchema = z.string().regex(
    /^\+[1-9]{1}[0-9]{3,14}$/,
    intl.formatMessage({
      id: 'validation.invalid_phone_number_format',
      defaultMessage: 'Invalid phone number format. Example: +306912345678',
    }),
  )

  const schema = z.object({
    username: mode === 'phone' ? phoneSchema : emailSchema,
    turnstileToken: z.string().min(
      1,
      intl.formatMessage({
        id: 'validation.turnstile_required',
        defaultMessage: 'Please complete the verification challenge',
      }),
    ),
  })

  return schema
}
